import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function validateDni(value: string): boolean {
  const dni = value.replace(/\D/g, '');
  return dni.length >= 7 && dni.length <= 8;
}

export const dniValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value as string;
  if (!value) return null;
  return validateDni(value) ? null : { invalidDocument: true };
};
